import BaseViewController from "./base-view-controller";

class ConsultationVpcAssessmentOneViewController extends BaseViewController {
  preprocessScreenData() {
    this.appData.values.suicide_alert_accepted = false;
  }
}
export default ConsultationVpcAssessmentOneViewController;
